module.exports = __webpack_public_path__ + "img/undo-checkout.7b1622a4.svg";